import { errorMessage } from './errorMessage';

type Translate = (key: string) => string;

const messages: Record<string, string> = {
  'Customer email already exists in this company!': 'customers.errors.emailAlreadyExists',
  'Customer email already exists in this company': 'customers.errors.emailAlreadyExists',
  'Customer tax identification number already exists in this company!': 'customers.errors.taxIdentificationNumberAlreadyExists',
  'Customer tax identification number already exists in this company': 'customers.errors.taxIdentificationNumberAlreadyExists',
  'A customer with this name already exists; provide a phone number, email, or tax identification number to distinguish the customer': 'customers.errors.duplicateNameRequiresIdentifier',
  'Customer already exists in this company': 'customers.errors.alreadyExistsInCompany',
};

export const formatCustomerError = (error: unknown, fallback: string, t: Translate): string => {
  const message = errorMessage(error, fallback);
  const translationKey = messages[message];
  return translationKey ? t(translationKey) : message;
};
